import { useEffect, useState } from "react";
import { CarouselPage } from "./CarouselPage";
import backIcon from '../assets/img/back.svg';
import downloadIcon from '../assets/img/download.svg';
import { buildTimeRange } from '../modules/utils';
import config from '../SysConfig.json';
import dayjs from 'dayjs';
import { annoHelper } from "../dal/annoHelper";
import { useLocation, useSearchParams } from 'react-router-dom';
import pre from "../assets/img/pre.svg";
import next from "../assets/img/next.svg";
import searchIcon from '../assets/img/search.svg';
import refreshIcon from '../assets/img/refresh.svg';
import { settingsHelper } from "../dal/settingsHelper"
import { set } from "react-datepicker/dist/date_utils";

export const NewsAll = () => {
  const [allNews, setAllNews] = useState<any[]>([]);
  const [filteredNews, setFilteredNews] = useState<any[]>([]);
  const [activePage, setActivePage] = useState(0);
  const [annoCount, setAnnoCount] = useState(0);
  const [query, setQuery] = useState('');
  const [reload, setReload] = useState(false);
  const [annoTags, setAnnoTags] = useState<string[]>([]);
  const [selectedAnnoTag, setSelectedAnnoTag] = useState<string>('');
  const [annoUnits, setAnnoUnits] = useState<string[]>([]);
  const [selectedAnnoUnit, setSelectedAnnoUnit] = useState<string>('');
  const [pageSize, setPageSize] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  const [searchParams] = useSearchParams();

  const initParam = searchParams.get("init") ?? 'default_value';

  const location = useLocation();



  const handlePageChange = async (newPage: number) => {
    setActivePage(newPage);
    setReload(true);
  };

  const initData = async () => {
    Promise.all([
      settingsHelper.getOpenGlobalSettingByKey('anno_tag'),
      settingsHelper.getOpenGlobalSettingByKey('anno_unit')
    ])
      .then((responses) => {
        setAnnoTags(responses[0].value.split(','));
        setAnnoUnits(responses[1].value.split(','));
      })
      .then(() => {
        annoHelper.getOpenAnnoCountWithFilters('', '', '')
          .then((rsp: any) => {
            const cnt = rsp.count;
            setAnnoCount(cnt);
            const total = Math.ceil(cnt / pageSize);
            setActivePage(0);
            setTotalPages(total);
          });
        annoHelper.getOpenConditionalAnnoWithFilters('', pageSize, activePage, '', '')
          .then((annos: any[]) => {
            setAllNews(annos);
            setFilteredNews(annos);
            setSelectedAnnoTag('');
            setSelectedAnnoUnit('');
          });
      });
  }

  const PrefilterData = async (qry: string, tag: string, unit: string, pageSize: number, activePage: number) => {
    Promise.all([
      settingsHelper.getOpenGlobalSettingByKey('anno_tag'),
      settingsHelper.getOpenGlobalSettingByKey('anno_unit')
    ])
      .then((responses) => {
        setAnnoTags(responses[0].value.split(','));
        setAnnoUnits(responses[1].value.split(','));
      });
    annoHelper.getOpenAnnoCountWithFilters(qry, tag, unit)
      .then((rsp: any) => {
        const cnt = rsp.count;
        setAnnoCount(cnt);
        const total = Math.ceil(cnt / pageSize);
        setTotalPages(total);
      });
    annoHelper.getOpenConditionalAnnoWithFilters(qry, pageSize, activePage, tag, unit)
      .then((annos: any[]) => {
        setAllNews(annos);
        setFilteredNews(annos);
      });
  }

  const filterData = async (qry: string, tag: string, unit: string, pageSize: number, activePage: number) => {
    annoHelper.getOpenAnnoCountWithFilters(qry, tag, unit)
      .then((rsp: any) => {
        const cnt = rsp.count;
        setAnnoCount(cnt);
        const total = Math.ceil(cnt / pageSize);
        setTotalPages(total);
      });
    annoHelper.getOpenConditionalAnnoWithFilters(qry, pageSize, activePage, tag, unit)
      .then((annos: any[]) => {
        setAllNews(annos);
        setFilteredNews(annos);
      });
  }
  const handleTagsSelected = async (value: string) => {
    const tag = (value === '選擇類別') ? '' : value;
    setSelectedAnnoTag(tag);
    setActivePage(0);
    setReload(true);
  }

  const handleUnitsSelected = async (value: string) => {
    const unit = (value === '公告單位') ? '' : value;
    setSelectedAnnoUnit(unit);
    setActivePage(0);
    setReload(true);
  }

  const handleReset = () => {
    setQuery('');
    setActivePage(0);
    setReload(true);
  }

  const handleKeywordSearch = (keyword: string) => {
    setQuery(keyword);
    setActivePage(0);
    setReload(true);
  }

  const handlePageSizeChange = async (size: number) => {
    setPageSize(size);
    setActivePage(0);
    setReload(true);
  };

  useEffect(() => {
    if (reload) {
      setReload(false);
      filterData(query, selectedAnnoTag, selectedAnnoUnit, pageSize, activePage);
    }
  }, [reload]);

  useEffect(() => {
    if (searchParams.get("init") === 'true') {
      initData();
    }
    else {
      const query = searchParams.get("query") || '';
      const limit = parseInt(searchParams.get("limit") || '20');
      const page = parseInt(searchParams.get("page") || '0');
      const tag = searchParams.get("tag") || '';
      const unit = searchParams.get("unit") || '';
      setQuery(query);
      setPageSize(limit);
      setActivePage(page);
      setSelectedAnnoTag(tag);
      setSelectedAnnoUnit(unit);
      PrefilterData(query, tag, unit, limit, page);
    }

  }, []);
  return (
    <div>
      <div className="max-w-7xl mx-auto">
        {/*<CarouselPage /> */}
      </div>
      <div className='content text-Headline px-4 mx-auto'>
        <div className='text-lg md:text-4xl w-fit border-b-4 border-primary font-medium my-6 md:my-8 p-1 md:p-3 mx-auto'>
          最新消息
        </div>

        <div className="grid grid-cols-3 lg:grid-cols-7 gap-x-4 gap-y-6 mb-6 lg:mb-8">
          <div className="col-span-2 hidden lg:block"></div>

          {/* Search box */}
          <div className="col-span-3 w-full sm:max-w-md mx-auto">
            <div className="input-group">
              <div className="input-group-prepend">
                <span id="basic-addon1" className="input-group-text !pr-0">
                  <img src={searchIcon} alt="" />
                </span>
              </div>
              <input
                type="text"
                placeholder="主旨、內容關鍵字搜尋"
                className="form-control"
                onChange={(e) => handleKeywordSearch(e.target.value)}
                value={query}
              />
              <div>
                <button
                  type="button"
                  className="flex py-2 px-3 border border-l-0 border-[#ced4da] rounded-r-full"
                  onClick={() => handleReset()}
                >
                  <img src={refreshIcon} alt="" />
                </button>
              </div>
            </div>
          </div>

          {/* Category selection */}
          <div className="col-span-3 lg:col-span-2 flex gap-4 ml-auto">
            <select
              className="bg-gray-50 border border-primary text-gray-900 text-sm rounded-lg block p-2.5"
              onChange={(e) => handleUnitsSelected(e.target.value)}
              value={(selectedAnnoUnit === '') ? '公告單位' : selectedAnnoUnit}
            >
              <option>公告單位</option>
              {annoUnits.map((unit, index) => (
                <option key={index} value={unit}>{unit}</option>
              ))}
              {/* {annoTags.map((tag, index) => (
                <option key={index} value={tag}>{tag}</option>
              ))} */}
            </select>
            <select
              className="bg-gray-50 border border-primary text-gray-900 text-sm rounded-lg block p-2.5"
              onChange={(e) => handleTagsSelected(e.target.value)}
              value={(selectedAnnoTag === '') ? '選擇類別' : selectedAnnoTag}
            >
              <option>選擇類別</option>
              {annoTags.map((tag, index) => (
                <option key={index} value={tag}>{tag}</option>
              ))}
            </select>
          </div>
        </div>

        {/* News content */}
        <div className="border-[3px] border-primary custom-shadow p-4 md:px-10 md:py-8">
          {filteredNews.map((item, index) => (
            <div key={index} className="flex flex-col md:flex-row items-baseline md:items-center text-base md:text-lg gap-y-1 gap-x-4 my-4 md:my-6">
              <div className="flex items-center gap-x-4 md:gap-x-6 text-nowrap">
                {item.is_top ? (
                  <div className='bt-yellow flex-shrink-0 w-20 md:w-24 text-center py-1'>
                    {item.unit_name}
                  </div>
                ) : (
                  <div className='bt-purple flex-shrink-0 w-20 md:w-24 text-center py-1'>
                    {item.unit_name}
                  </div>
                )}
                <div className='text-primary border rounded border-primary text-sm px-2'>{item.anno_tag}</div>
              </div>
              <div className="flex items-center gap-2 flex-grow">

                {item.is_top && <span className='text-warning border rounded border-warning text-sm px-2 text-nowrap'>置頂</span>}
                <a href={`/newsview?itemid=${item.id}`}
                  className="hover:underline clamp2"
                >
                  {item.title}
                </a>
              </div>
              <div className="shrink-0 text-[#9b9b9b] text-sm md:text-base ml-auto">
                {buildTimeRange((item.start_at) ? item.start_at : '', (item.end_at) ? item.end_at : '')}
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row justify-between items-center gap-6 mt-8">
          <div className="hidden sm:block sm:mr-auto w-28"></div>

          {/* Pagination controls */}
          <div className="flex items-center gap-4 mx-auto">
            <button
              onClick={() => handlePageChange(activePage - 1)}
              disabled={activePage === 0}
              className="disabled:opacity-50 hover:opacity-75"
            >
              <img src={pre} alt="Previous" className="w-4 h-4" />
            </button>

            <div className="flex items-center gap-2">
              <select
                value={activePage}
                onChange={(e) => handlePageChange(Number(e.target.value))}
                className="bg-gray-50 border border-primary text-gray-900 text-sm rounded-lg block p-2"
              >
                {Array.from({ length: totalPages }, (_, i) => (
                  <option key={i} value={i}>{i + 1}</option>
                ))}
              </select>
              <div className="flex text-gray-600 gap-2">
                <div>of</div>
                <div>{totalPages}</div>
              </div>
            </div>

            <button
              onClick={() => handlePageChange(activePage + 1)}
              disabled={activePage === totalPages - 1}
              className="disabled:opacity-50 hover:opacity-75"
            >
              <img src={next} alt="Next" className="w-4 h-4" />
            </button>
            <div className="text-primary">共{annoCount}筆</div>

          </div>

          {/* Page size selector and total records */}
          <div className="flex items-center gap-2 mx-auto sm:mr-0">
            <select
              className="bg-gray-50 border border-primary text-gray-900 text-sm rounded-lg block p-2"
              value={pageSize}
              onChange={(e) => handlePageSizeChange(Number(e.target.value))}
            >
              <option value={20}>20 筆</option>
              <option value={30}>30 筆</option>
              <option value={50}>50 筆</option>
            </select>
            <div>每頁</div>
          </div>


        </div>
      </div>

      <div className="p-7 md:p-16"></div>
    </div>
  );
};